import React from "react";
import { observer } from "mobx-react";
import { AlertSubscriptionViewStore } from "../../store";
import { AlertSubscriptionViewForm } from "./AlertSubscriptionViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type AlertSubscriptionViewProps = {
  alertSubscriptionViewStore: AlertSubscriptionViewStore;
};

export const AlertSubscriptionView: React.FC<AlertSubscriptionViewProps> =
  observer(({ alertSubscriptionViewStore }) => {
    return (
      <div>
        <AlertSubscriptionViewForm
          alertRuleValue={alertSubscriptionViewStore.alertRuleValue}
          enabled={alertSubscriptionViewStore.enabledValue}
          onPrint={(handlePrint: () => void) =>
            alertSubscriptionViewStore.printAlertSubscription(handlePrint)
          }
          onCancel={() => alertSubscriptionViewStore.cancelAlertSubscription()}
          onEdit={
            alertSubscriptionViewStore.isEditEnabled
              ? () => alertSubscriptionViewStore.editAlertSubscription()
              : undefined
          }
        />
        <ErrorDialog
          open={alertSubscriptionViewStore.errorDialogOpened}
          title={alertSubscriptionViewStore.errorTitle}
          description={alertSubscriptionViewStore.errorDescription}
          onClose={() => alertSubscriptionViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
